(function () {
  'use strict';

  // Aspetta che il DOM sia pronto
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const optionalsContainer = document.getElementById('product-optionals');
    if (!optionalsContainer) return; // nessun optional su questa pagina

    interceptAddToCart();
  }

  function interceptAddToCart() {
    // Il tema usa un <button type="submit" class="add-cart-button">
    const addToCartBtn = document.querySelector('.add-cart-button');
    if (!addToCartBtn) return;

    addToCartBtn.addEventListener('click', handleAddToCart);
  }

  function handleAddToCart(e) {
    const checkedOptionals = document.querySelectorAll('.optional-checkbox:checked');
    if (checkedOptionals.length === 0) return; // nessun optional, lascia fare al tema

    e.preventDefault();
    e.stopImmediatePropagation();

    const mainVariantInput = document.querySelector('input[name="id"]');
    const quantityInput = document.querySelector('input[name="quantity"]');

    if (!mainVariantInput) return;

    const mainVariantId = parseInt(mainVariantInput.value);
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    const items = [
      { id: mainVariantId, quantity: quantity }
    ];

    checkedOptionals.forEach(function (checkbox) {
      items.push({
        id: parseInt(checkbox.dataset.variantId),
        quantity: 1 // gli optional si aggiungono sempre in quantità 1
      });
    });

    addItemsToCart(items);
  }

async function addItemsToCart(items) {
  const addToCartBtn = document.querySelector('.add-cart-button');

  if (addToCartBtn) {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('loading');
  }

  try {
    // Recupera il carrello attuale
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const mainItem = items[0]; // il prodotto principale è sempre il primo
    const optionalItems = items.slice(1); // gli optional sono il resto

    // Controlla se il prodotto principale è già nel carrello
    const alreadyInCart = cart.items.some(function(cartItem) {
      return cartItem.variant_id === mainItem.id;
    });

    // Se è già nel carrello, aggiungi solo gli optional
    const itemsToAdd = alreadyInCart ? optionalItems : items;

    if (itemsToAdd.length === 0) {
      // Nessun optional e prodotto già nel carrello: non fare nulla
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('loading');
      }
      return;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Errore aggiunta al carrello');
    }

    window.location.href = '/cart';

  } catch (err) {
    console.error('[product-optionals]', err);
    alert('Errore: ' + err.message);

    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('loading');
    }
  }
}

})();